import { useState } from 'react'
import useProductCategories from '../../../hooks/useProductCategories'
import { CheckCircleIcon } from '@heroicons/react/24/solid'
import Modal from '../../common/Modal'
import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from '../../../utils/queryKeyGenerator'
import { handleGetRequest } from '../../../utils/api-handler.util'
import Pagination from '../../common/Pagination'

const ProductPickerModal = ({ onClose, onSelect, finderCategoryId = '' }) => {
  const [page, setPage] = useState(1)
  const { getCategoryNameById, getCategoryById } = useProductCategories()
  const [selectedProductId, setSelectedProductId] = useState(null)
  const params = {
    categorySlug: getCategoryById(finderCategoryId)?.categorySlug,
    page: page,
  }
  const { data: productsData, isLoading: loading } = useQuery({
    queryKey: QueryKeys.retailerProducts(params),
    queryFn: () => handleGetRequest('/retailers/my-products', params),
  })

  const filteredProducts = productsData?.data || []

  const handleProductSelect = (product) => {
    onSelect(product)
    setSelectedProductId(product.id)
    onClose()
  }

  const renderProduct = (product) => {
    return (
      <div
        key={product.id}
        className={`relative rounded-md bg-background border px-2 py-2 hover:border-success-500 cursor-pointer ${
          selectedProductId === product.id ? 'border-success-500' : ' border-gray-100 '
        }`}
        onClick={() => handleProductSelect(product)}
      >
        <img src={product.primaryImageUrl} alt={product.name} className="w-64  aspect-square" />
        <div className="flex justify-between items-center mt-2">
          <div>
            <div className="text-black text-sm font-medium text-center  px-1">{product.name}</div>
            <div className="text-xs text-center text-gray-500  px-1">
              {getCategoryNameById(product.categoryId) || 'Uncategorized'}
            </div>
            <div className="text-xs text-center text-gray-500  px-1">{product.priceText}</div>
          </div>
          <CheckCircleIcon
            className={`text-success-500 ${
              selectedProductId === product.id ? 'visible' : 'invisible'
            }`}
          />
        </div>
      </div>
    )
  }

  const renderContent = () => {
    if (loading) {
      return <div className="text-center text-gray-500">Loading products...</div>
    }

    if (filteredProducts.length === 0) {
      return (
        <div className="text-center text-gray-500">
          You do not have any products in the{' '}
          <strong>{getCategoryNameById(finderCategoryId) || 'selected'}</strong> category.
          <br />
          Please add products in this category to continue.
        </div>
      )
    }

    return (
      <>
        <div className="grid grid-cols-3 gap-3 mb-8">
          {filteredProducts.map((product) => renderProduct(product))}
        </div>
        <Pagination paginationMeta={productsData?.meta} onPageChange={setPage} />
      </>
    )
  }

  return (
    <Modal isOpen={true} onClose={onClose}>
      <h2 className="text-center text-2xl font-bold mb-6">Product Picker</h2>
      {renderContent()}
    </Modal>
  )
}

export default ProductPickerModal
